import { FetchStatus } from '@flatsy/types/FetchStatus'
import { createAsyncThunk } from '@reduxjs/toolkit'
import * as URLS from 'src/constants/Api'
import client, { FlatsyApiError } from 'src/utils/client'
import { RootState } from '../..'
import { qualificationConfig } from './Type'

export const fetchQualification = createAsyncThunk<
  qualificationConfig,
  string,
  {
    rejectValue: FlatsyApiError
  }
>(
  'application/fetchQualification',
  async (applicationId, { rejectWithValue }) => {
    return client<qualificationConfig>(URLS.PUBLIC_QUALIFICATION(applicationId)).catch((err) => {
      return rejectWithValue(err)
    })
  },
  {
    condition: (_, { getState }) => {
      const { status } = (getState as () => RootState)().qualificationConfig
      if (FetchStatus.LOADING === status) {
        // Already fetched or in progress, don't need to re-fetch
        return false
      }
    },
  }
)
